export default function (entity, changes) {

    console.log('debugging :', 'component', '\'' + 'state' + '\'');
    console.log(changes);
    console.log('debugging :', 'entity', '\'' + entity.name + '\'');
    console.log(entity);
};
